<template>
    <div>
        <el-table
            :data="tableData"
            border
            size="mini"
            style="width: 100%"
            :close-on-click-modal="false"
            @selection-change="handleSelectionChange"
        >
            <el-table-column
                v-if="isTableMultiple"
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                type="index"
                width="100"
                label="序号"
            ></el-table-column>
            <el-table-column
                prop="approveTypeShow"
                label="审批流类型"
                width="120px"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="applyDeptName"
                label="项目部"
                width="120px"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="projectName"
                label="项目名称"
                width="120px"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="itemName"
                label="审批内容"
                class-name="itemNameClass"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="submitUserName"
                label="提交人"
                width="120px"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="createTime"
                label="提交时间"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="submitUserDeptName"
                label="提交人部门"
                width="120px"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="statusShow"
                label="审批状态"
                width="120px"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
            v-if="jumpType=='submitUnapproval'"
                prop="approveUserName"
                label="当前审批人"
                width="120px"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        size="mini"
                        @click="handleClick(scope.row, leftActionBtn)"
                        v-if="
							(scope.row.isBackAllowed &&
								leftActionBtn == '取消审批') ||
								leftActionBtn == '审批'
						"
                    >{{ leftActionBtn }}
                    </el-button>
                    <el-button
                    v-if="jumpType=='submitUnapproval'"
                        type="text"
                        size="mini"
                        @click="handleClick(scope.row, rightActionBtn)"
                    >{{ rightActionBtn }} </el-button>
                    <el-button
                    v-else
                        type="text"
                        size="mini"
                        @click="handleClick(scope.row, rightActionBtn)"
                    >{{ rightActionBtn }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "table",
    props: {
        tableData: {
            type: Array,
        },
        leftActionBtn: {
            type: String,
        },
        rightActionBtn: {
            type: String,
        },
        isTableMultiple: {
            type: Boolean,
            defaule: false
        },
        selectList: {
            type: Array
        },
        jumpType:{
            type:String

        },


    },
    methods: {
        handleClick(row, btnName) {
            this.$emit("actionBtnClick", {
                row,
                btnName,
            });
        },
        handleSelectionChange(val) {
            this.$emit("update:selectList", val)
        }
    },
};
</script>

<style scoped lang="scss">
::v-deep td.itemNameClass .cell {
    color: red;
}
</style>
